import React, { useState, useEffect } from "react";
import TrendingCard from "../components/TrendingCard";
import SummaryApi from "../common";

const TrendingProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get user data to check subscription status
  const userData = JSON.parse(localStorage.getItem("user") || "null");
  const isSubscriber = userData?.is_subscriber === 1;

  const fetchTrendingProducts = async () => {
    try {
      setLoading(true);
      const response = await fetch(SummaryApi.getActiveProduct.url, {
        method: SummaryApi.getActiveProduct.method,
      });
      const dataResponse = await response.json();

      if (dataResponse.status) {
        setProducts(dataResponse.data);
      } else {
        setError("Failed to fetch products");
      }
    } catch (err) {
      setError("Server error.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrendingProducts();
  }, []);

  if (loading) return <div className="text-center py-20">Loading...</div>;

  return (
    <div className="py-12">
      <div className="w-[85%] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-pink-800 mb-4 tracking-tight">
            Trending Products
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {products.map((product) => {
            // Clean the Base URL
            const cleanBaseUrl = SummaryApi.productImage.url.replace('/api/uploads', '');

            // Image path logic
            const imgPath = product.product_image1;
            const cleanImagePath = imgPath?.startsWith('/') ? imgPath.substring(1) : imgPath;
            
            const finalImageUrl = cleanImagePath 
                ? `${cleanBaseUrl}/${cleanImagePath}` 
                : "https://via.placeholder.com/400";

            // LOGIC: Subscriber Benefit for Leaf/Sakhi Pads
            const isLeaf = product.product_title?.toLowerCase().includes("leaf") || 
                           product.product_title?.toLowerCase().includes("sakhi");

            let displaySellingPrice = product.selling_price;
            let displayActualPrice = product.actual_price;

            if (isSubscriber && isLeaf) {
              // Override: Strike off ₹15.00 and show ₹12.00
              displayActualPrice = "15.00";
              displaySellingPrice = "12.00";
            }

            return (
              <div key={product.product_id} className="relative group">
                <TrendingCard
                  name={product.product_title}
                  selling_price={displaySellingPrice}
                  actual_price={displayActualPrice}
                  image={finalImageUrl}
                />
                
                {/* Optional: Add Subscriber Benefit Badge similar to Products.jsx */}
                {isSubscriber && isLeaf && (
                  <div className="absolute top-2 right-2 z-10">
                    <span className="bg-emerald-100 text-emerald-600 text-[8px] md:text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-tighter shadow-sm border border-emerald-200">
                      Subscriber Benefit
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrendingProducts;